export const blockIconsCommonactionsCelebrationNew = (
	<span className='material-symbols-outlined'>celebration</span>
);
